import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserInfo } from '../../models/UserInfo';

export interface UserInfoState {
  userInfoState: IUserInfo;
  isUserInfoDownloaded: boolean;
}

export const initialState: UserInfoState = {
  userInfoState: {
    id: 0,
    Name: '',
    TypeID: 0,
    Addresses: [],
    Phones: [],
    Balance: 0,
    Bonus: 0,
    CreateDate: '',
    MultiAccount: {
      Type: 'family',
    },
    EmailSettings: {
      Email: '',
      Accept: false,
      NoBalance: false,
      News: false,
      Repairs: false,
      IsBlocked: false,
      IsConfirmed: false,
      CreateDate: '',
    },
    SmsSettings: {
      Phone: '',
      Accept: false,
      NoBalance: false,
      News: false,
      Repairs: false,
      IsBlocked: false,
      CreateDate: '',
    },
    PushSettings: {
      Accept: false,
      NoBalance: false,
      News: false,
      Repairs: false,
    },
    SocialAccounts: [],
    Equipments: [],
    Permissions: {
      Info: {
        ShowBonuses: true,
      },
      Payments: {
        AddMoney: true,
        PrepayDiscount: true,
        RegularPayment: true,
      },
      Services: {
        Activate: true,
        Change: true,
        Suspend: true,
        Internet: {
          CanEdit: true,
        },
        Iptv: {
          CanAdd: true,
          CanEdit: true,
          CanRemove: true,
          BrizTVAvailable: true,
        },
      },
      ServicesEx: {
        Activate: true,
      },
    },
    HasUnreadPushes: false,
    Language: 'ua',
    Entrepreneur: {
      PlatonKey: '',
      PlatonPassword: '',
    },
    Shares: {
      Activated: [],
    },
  },
  isUserInfoDownloaded: false,
};

export const userInfoSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setUserInfo(state, { payload }: PayloadAction<UserInfoState>) {
      state.userInfoState = payload.userInfoState;
      state.isUserInfoDownloaded = payload.isUserInfoDownloaded;
    },
    updateUserBalance(state, { payload }: PayloadAction<{ balance: number; bonus: number }>) {
      state.userInfoState = { ...state.userInfoState, Balance: payload.balance, Bonus: payload.bonus };
    },
    resetUserInfoAfterLogout(state) {
      state.userInfoState = initialState.userInfoState;
      state.isUserInfoDownloaded = false;
    },
  },
});

export default userInfoSlice.reducer;
